export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9775.0bcd8a0c.jpg";